import React from "react";
import {
  FaQuoteLeft,
  FaQuoteRight,
  FaGraduationCap,
  FaArrowRight,
  FaAward,
  FaHeart,
  FaBookOpen,
  FaStar,
  FaShieldAlt,
  FaCheckCircle,
} from "react-icons/fa";

import Footer from "./Footer";
import proprietorImage from "./mrsamkargbo.jpg";

const styles = `
  .zpa-proprietor,
  .zpa-proprietor * {
    box-sizing: border-box;
  }

  .zpa-proprietor {
    --zpa-black: #111111;
    --zpa-black-soft: #1c1c1c;
    --zpa-gold: #d5a62e;
    --zpa-gold-light: #f1d58a;
    --zpa-gold-pale: #fff8e7;
    --zpa-text: #292929;
    --zpa-muted: #666666;
    --zpa-border: #eae4d6;

    position: relative;
    isolation: isolate;
    overflow: hidden;
    padding: 94px 24px 100px;
    color: var(--zpa-text);
    background:
      radial-gradient(
        ellipse at 4% 8%,
        rgba(213, 166, 46, 0.10),
        transparent 30%
      ),
      linear-gradient(180deg, #ffffff 0%, #fcfbf8 100%);
    font-family: inherit;
  }

  .zpa-proprietor a {
    color: inherit;
    text-decoration: none;
  }

  .zpa-proprietor button,
  .zpa-proprietor a {
    -webkit-tap-highlight-color: transparent;
  }

  .zpa-proprietor .zpa-background-shape {
    position: absolute;
    z-index: -1;
    pointer-events: none;
    border: 1px solid rgba(213, 166, 46, 0.19);
    border-radius: 50%;
  }

  .zpa-proprietor .zpa-shape-one {
    width: 360px;
    height: 360px;
    top: -205px;
    right: -115px;
  }

  .zpa-proprietor .zpa-shape-two {
    width: 230px;
    height: 230px;
    bottom: 40px;
    left: -145px;
    background: rgba(213, 166, 46, 0.035);
  }

  .zpa-proprietor .zpa-container {
    width: 100%;
    max-width: 1240px;
    margin: 0 auto;
  }

  .zpa-proprietor .zpa-heading {
    max-width: 790px;
    margin: 0 auto 65px;
    text-align: center;
  }

  .zpa-proprietor .zpa-eyebrow {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 11px;
    margin-bottom: 20px;
    color: #94701b;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 2.6px;
    text-transform: uppercase;
  }

  .zpa-proprietor .zpa-eyebrow-line {
    width: 32px;
    height: 2px;
    border-radius: 3px;
    background: var(--zpa-gold);
  }

  .zpa-proprietor .zpa-school-mark {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 9px;
    margin-bottom: 17px;
    color: #777;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  .zpa-proprietor .zpa-school-mark svg {
    color: #b18420;
    font-size: 18px;
  }

  .zpa-proprietor .zpa-heading h2 {
    margin: 0;
    color: var(--zpa-black);
    font-size: clamp(34px, 4.5vw, 56px);
    font-weight: 850;
    letter-spacing: -1.9px;
    line-height: 1.13;
  }

  .zpa-proprietor .zpa-heading h2 span {
    display: block;
    margin-top: 7px;
    color: #ad8120;
  }

  .zpa-proprietor .zpa-heading p {
    max-width: 650px;
    margin: 22px auto 0;
    color: var(--zpa-muted);
    font-size: 15px;
    line-height: 1.95;
  }

  .zpa-proprietor .zpa-heading-rule {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    margin-top: 27px;
  }

  .zpa-proprietor .zpa-heading-rule span {
    display: block;
    height: 4px;
    border-radius: 4px;
  }

  .zpa-proprietor .zpa-heading-rule span:nth-child(1) {
    width: 22px;
    background: #222;
  }

  .zpa-proprietor .zpa-heading-rule span:nth-child(2) {
    width: 48px;
    background: var(--zpa-gold);
  }

  .zpa-proprietor .zpa-heading-rule span:nth-child(3) {
    width: 22px;
    background: #222;
  }

  .zpa-proprietor .zpa-content {
    display: grid;
    grid-template-columns: minmax(300px, 0.84fr) minmax(0, 1.35fr);
    align-items: start;
    gap: 48px;
  }

  /* Proprietor profile */

  .zpa-proprietor .zpa-image-column {
    min-width: 0;
    padding: 12px 10px 15px 0;
  }

  .zpa-proprietor .zpa-image-wrapper {
    position: relative;
    width: 100%;
    max-width: 435px;
    margin: 0 auto;
    padding: 0 18px 20px 0;
  }

  .zpa-proprietor .zpa-image-frame {
    position: relative;
    z-index: 1;
    overflow: hidden;
    width: 100%;
    aspect-ratio: 4 / 5.1;
    border: 8px solid #fff;
    border-radius: 7px;
    background: #e9e4d9;
    box-shadow:
      0 22px 65px rgba(0, 0, 0, 0.13),
      0 0 0 1px rgba(213, 166, 46, 0.25);
  }

  .zpa-proprietor .zpa-image-frame::after {
    position: absolute;
    inset: 0;
    border: 1px solid rgba(255, 255, 255, 0.25);
    content: "";
    pointer-events: none;
  }

  .zpa-proprietor .zpa-image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    transition: transform 0.65s ease;
  }

  .zpa-proprietor .zpa-image-wrapper:hover .zpa-image {
    transform: scale(1.035);
  }

  .zpa-proprietor .zpa-image-accent {
    position: absolute;
    pointer-events: none;
  }

  .zpa-proprietor .zpa-accent-one {
    z-index: -1;
    top: -12px;
    right: 0;
    width: 56%;
    height: 58%;
    border-top: 5px solid var(--zpa-gold);
    border-right: 5px solid var(--zpa-gold);
  }

  .zpa-proprietor .zpa-accent-two {
    z-index: 0;
    bottom: 0;
    left: -12px;
    width: 53%;
    height: 35%;
    background: var(--zpa-black);
    opacity: 0.96;
  }

  .zpa-proprietor .zpa-role-card {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 15px;
    width: calc(100% - 12px);
    max-width: 350px;
    margin: -65px 0 0 auto;
    padding: 20px 21px;
    color: #fff;
    background: linear-gradient(130deg, #111111 0%, #29251b 100%);
    border-left: 4px solid var(--zpa-gold);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.20);
  }

  .zpa-proprietor .zpa-role-icon {
    display: flex;
    flex: 0 0 49px;
    align-items: center;
    justify-content: center;
    width: 49px;
    height: 49px;
    color: var(--zpa-black);
    background: linear-gradient(135deg, #f4df9d, #c99a27);
    border-radius: 4px;
    font-size: 23px;
  }

  .zpa-proprietor .zpa-role-card div:last-child {
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
  }

  .zpa-proprietor .zpa-role-card span {
    color: #d6d1c5;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
  }

  .zpa-proprietor .zpa-role-card strong {
    color: #fff;
    font-size: 21px;
    font-weight: 800;
  }

  .zpa-proprietor .zpa-profile-caption {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    max-width: 365px;
    margin: 25px auto 0;
    padding: 0 5px;
    color: #777;
    font-size: 12px;
    line-height: 1.8;
  }

  .zpa-proprietor .zpa-profile-caption svg {
    flex-shrink: 0;
    margin-top: 3px;
    color: #b68b28;
    font-size: 15px;
  }

  /* Message card */

  .zpa-proprietor .zpa-message-column {
    min-width: 0;
  }

  .zpa-proprietor .zpa-message-card {
    position: relative;
    padding: 38px 38px 31px;
    border: 1px solid #eee8db;
    border-top: 4px solid var(--zpa-gold);
    border-radius: 5px;
    background: #fff;
    box-shadow: 0 17px 55px rgba(28, 25, 17, 0.055);
  }

  .zpa-proprietor .zpa-quote-icon {
    position: absolute;
    top: 29px;
    right: 31px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 47px;
    height: 47px;
    color: #9e771e;
    background: var(--zpa-gold-pale);
    border-radius: 50%;
    font-size: 19px;
  }

  .zpa-proprietor .zpa-message-top {
    display: flex;
    align-items: center;
    gap: 14px;
    padding-right: 55px;
    margin-bottom: 21px;
  }

  .zpa-proprietor .zpa-message-label {
    color: #96701d;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 1.8px;
    line-height: 1.6;
    text-transform: uppercase;
  }

  .zpa-proprietor .zpa-message-line {
    width: 42px;
    height: 2px;
    flex-shrink: 0;
    background: var(--zpa-gold);
  }

  .zpa-proprietor .zpa-message-card h3 {
    margin: 0 0 24px;
    color: var(--zpa-black);
    font-size: clamp(25px, 3vw, 35px);
    font-weight: 850;
    letter-spacing: -0.8px;
    line-height: 1.34;
  }

  .zpa-proprietor .zpa-message-card h3 span {
    color: #ae8425;
  }

  .zpa-proprietor .zpa-message {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .zpa-proprietor .zpa-message p {
    margin: 0;
    color: #5c5c5c;
    font-size: 13.5px;
    line-height: 1.95;
  }

  .zpa-proprietor .zpa-signature {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: 29px;
    padding-top: 24px;
    border-top: 1px solid #eee9df;
  }

  .zpa-proprietor .zpa-signature-mark {
    display: flex;
    flex: 0 0 45px;
    align-items: center;
    justify-content: center;
    width: 45px;
    height: 45px;
    color: #fff;
    background: var(--zpa-black);
    border-bottom: 3px solid var(--zpa-gold);
    border-radius: 3px;
    font-size: 16px;
  }

  .zpa-proprietor .zpa-signature-text {
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
  }

  .zpa-proprietor .zpa-signature-text strong {
    color: #1b1b1b;
    font-size: 14px;
    font-weight: 800;
    line-height: 1.5;
  }

  .zpa-proprietor .zpa-signature-text span {
    color: #9a7727;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.8px;
    text-transform: uppercase;
  }

  /* Values */

  .zpa-proprietor .zpa-values {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    margin-top: 19px;
  }

  .zpa-proprietor .zpa-value {
    display: flex;
    align-items: flex-start;
    gap: 13px;
    min-width: 0;
    padding: 20px 17px;
    border: 1px solid #eee8dc;
    border-radius: 4px;
    background: #fff;
    transition:
      transform 0.25s ease,
      border-color 0.25s ease,
      box-shadow 0.25s ease;
  }

  .zpa-proprietor .zpa-value:hover {
    transform: translateY(-4px);
    border-color: #d9bd78;
    box-shadow: 0 12px 25px rgba(25, 25, 25, 0.055);
  }

  .zpa-proprietor .zpa-value-icon {
    display: flex;
    flex: 0 0 39px;
    align-items: center;
    justify-content: center;
    width: 39px;
    height: 39px;
    color: #99721b;
    background: var(--zpa-gold-pale);
    border-radius: 4px;
    font-size: 17px;
  }

  .zpa-proprietor .zpa-value > div:last-child {
    min-width: 0;
  }

  .zpa-proprietor .zpa-value strong {
    display: block;
    margin: 1px 0 7px;
    color: #222;
    font-size: 12px;
    font-weight: 800;
    line-height: 1.5;
  }

  .zpa-proprietor .zpa-value span {
    display: block;
    color: #727272;
    font-size: 11px;
    line-height: 1.75;
  }

  .zpa-proprietor .zpa-read-more {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-top: 24px;
    padding: 15px 21px;
    color: #fff;
    background: var(--zpa-black);
    border: 1px solid var(--zpa-black);
    border-radius: 3px;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.25px;
    transition:
      color 0.25s ease,
      background 0.25s ease,
      border-color 0.25s ease,
      transform 0.25s ease;
  }

  .zpa-proprietor .zpa-read-more svg {
    color: var(--zpa-gold-light);
    transition: transform 0.25s ease;
  }

  .zpa-proprietor .zpa-read-more:hover {
    color: #111;
    background: var(--zpa-gold);
    border-color: var(--zpa-gold);
    transform: translateY(-2px);
  }

  .zpa-proprietor .zpa-read-more:hover svg {
    color: #111;
    transform: translateX(4px);
  }

  .zpa-proprietor .zpa-read-more:focus-visible {
    outline: 3px solid rgba(213, 166, 46, 0.5);
    outline-offset: 4px;
  }

  /* School commitment strip */

  .zpa-proprietor .zpa-commitment {
    position: relative;
    display: grid;
    grid-template-columns: 1.3fr repeat(3, minmax(0, 1fr));
    align-items: center;
    gap: 0;
    margin-top: 76px;
    overflow: hidden;
    color: #fff;
    background: linear-gradient(115deg, #111 0%, #222019 100%);
    border-radius: 5px;
  }

  .zpa-proprietor .zpa-commitment-intro {
    padding: 31px 30px;
  }

  .zpa-proprietor .zpa-commitment-intro span {
    display: block;
    margin-bottom: 10px;
    color: var(--zpa-gold-light);
    font-size: 9px;
    font-weight: 800;
    letter-spacing: 1.8px;
    text-transform: uppercase;
  }

  .zpa-proprietor .zpa-commitment-intro h4 {
    margin: 0;
    color: #fff;
    font-size: 21px;
    font-weight: 800;
    line-height: 1.45;
  }

  .zpa-proprietor .zpa-commitment-item {
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 75px;
    padding: 20px 18px;
    border-left: 1px solid rgba(255, 255, 255, 0.13);
  }

  .zpa-proprietor .zpa-commitment-item svg {
    flex-shrink: 0;
    color: var(--zpa-gold-light);
    font-size: 20px;
  }

  .zpa-proprietor .zpa-commitment-item span {
    color: #f2f0e9;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.7;
  }

  .zpa-proprietor .zpa-bottom-note {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 9px;
    margin-top: 27px;
    color: #777;
    font-size: 11px;
    line-height: 1.8;
    text-align: center;
  }

  .zpa-proprietor .zpa-bottom-note svg {
    flex-shrink: 0;
    color: #ad8428;
  }

  @media (min-width: 1500px) {
    .zpa-proprietor {
      padding-top: 110px;
      padding-bottom: 115px;
    }

    .zpa-proprietor .zpa-container {
      max-width: 1320px;
    }

    .zpa-proprietor .zpa-content {
      gap: 60px;
    }
  }

  @media (max-width: 1050px) {
    .zpa-proprietor {
      padding: 76px 22px 80px;
    }

    .zpa-proprietor .zpa-content {
      grid-template-columns: minmax(250px, 0.78fr) minmax(0, 1.25fr);
      gap: 30px;
    }

    .zpa-proprietor .zpa-message-card {
      padding: 31px 27px 27px;
    }

    .zpa-proprietor .zpa-values {
      grid-template-columns: 1fr;
    }

    .zpa-proprietor .zpa-commitment {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .zpa-proprietor .zpa-commitment-intro {
      grid-column: 1 / -1;
      padding: 25px 27px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.13);
    }

    .zpa-proprietor .zpa-commitment-intro h4 {
      max-width: 480px;
    }

    .zpa-proprietor .zpa-commitment-item:first-of-type {
      border-left: none;
    }
  }

  @media (max-width: 760px) {
    .zpa-proprietor {
      padding: 62px 18px 65px;
    }

    .zpa-proprietor .zpa-heading {
      margin-bottom: 43px;
    }

    .zpa-proprietor .zpa-heading h2 {
      font-size: clamp(32px, 7vw, 44px);
      letter-spacing: -1.2px;
    }

    .zpa-proprietor .zpa-heading p {
      font-size: 13px;
      line-height: 1.85;
    }

    .zpa-proprietor .zpa-content {
      grid-template-columns: 1fr;
      gap: 36px;
    }

    .zpa-proprietor .zpa-image-column {
      padding: 5px 5px 0;
    }

    .zpa-proprietor .zpa-image-wrapper {
      max-width: 390px;
    }

    .zpa-proprietor .zpa-image-frame {
      aspect-ratio: 4 / 4.5;
    }

    .zpa-proprietor .zpa-profile-caption {
      margin-top: 22px;
    }

    .zpa-proprietor .zpa-message-card {
      padding: 30px 25px 26px;
    }

    .zpa-proprietor .zpa-message-card h3 {
      font-size: clamp(26px, 5vw, 34px);
    }

    .zpa-proprietor .zpa-message p {
      font-size: 13px;
    }

    .zpa-proprietor .zpa-commitment {
      margin-top: 48px;
    }
  }

  @media (max-width: 480px) {
    .zpa-proprietor {
      padding: 49px 14px 52px;
    }

    .zpa-proprietor .zpa-eyebrow {
      gap: 8px;
      font-size: 9px;
      letter-spacing: 1.7px;
    }

    .zpa-proprietor .zpa-eyebrow-line {
      width: 22px;
    }

    .zpa-proprietor .zpa-school-mark {
      font-size: 9px;
      letter-spacing: 1.5px;
    }

    .zpa-proprietor .zpa-heading h2 {
      font-size: 32px;
    }

    .zpa-proprietor .zpa-heading p {
      font-size: 12.5px;
    }

    .zpa-proprietor .zpa-role-card {
      gap: 12px;
      padding: 16px;
    }

    .zpa-proprietor .zpa-role-icon {
      flex-basis: 42px;
      width: 42px;
      height: 42px;
      font-size: 20px;
    }

    .zpa-proprietor .zpa-role-card strong {
      font-size: 18px;
    }

    .zpa-proprietor .zpa-message-card {
      padding: 25px 18px 22px;
    }

    .zpa-proprietor .zpa-quote-icon {
      top: 20px;
      right: 17px;
      width: 38px;
      height: 38px;
      font-size: 15px;
    }

    .zpa-proprietor .zpa-message-top {
      gap: 9px;
      padding-right: 35px;
    }

    .zpa-proprietor .zpa-message-label {
      font-size: 9px;
      letter-spacing: 1px;
    }

    .zpa-proprietor .zpa-message-line {
      width: 22px;
    }

    .zpa-proprietor .zpa-message-card h3 {
      font-size: 26px;
      letter-spacing: -0.5px;
    }

    .zpa-proprietor .zpa-message {
      gap: 13px;
    }

    .zpa-proprietor .zpa-message p {
      font-size: 12.5px;
      line-height: 1.85;
    }

    .zpa-proprietor .zpa-signature {
      align-items: flex-start;
      gap: 11px;
    }

    .zpa-proprietor .zpa-signature-text strong {
      font-size: 12px;
    }

    .zpa-proprietor .zpa-values {
      gap: 10px;
    }

    .zpa-proprietor .zpa-value {
      gap: 11px;
      padding: 16px 13px;
    }

    .zpa-proprietor .zpa-value strong {
      font-size: 11.5px;
    }

    .zpa-proprietor .zpa-value span {
      font-size: 10.5px;
    }

    .zpa-proprietor .zpa-read-more {
      width: 100%;
      padding: 15px;
    }

    .zpa-proprietor .zpa-commitment {
      grid-template-columns: 1fr;
    }

    .zpa-proprietor .zpa-commitment-intro {
      padding: 23px 21px;
    }

    .zpa-proprietor .zpa-commitment-intro h4 {
      font-size: 19px;
    }

    .zpa-proprietor .zpa-commitment-item {
      min-height: 60px;
      padding: 16px 21px;
      border-left: none;
      border-bottom: 1px solid rgba(255, 255, 255, 0.10);
    }

    .zpa-proprietor .zpa-commitment-item:last-child {
      border-bottom: none;
    }

    .zpa-proprietor .zpa-bottom-note {
      align-items: flex-start;
      font-size: 10px;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .zpa-proprietor *,
    .zpa-proprietor *::before,
    .zpa-proprietor *::after {
      scroll-behavior: auto !important;
      transition-duration: 0.01ms !important;
      animation-duration: 0.01ms !important;
    }
  }
`;

const PrincipalMessagePage = () => {
  return (
    <>
      <style>{styles}</style>

      <main className="zpa-proprietor">
        <div
          className="zpa-background-shape zpa-shape-one"
          aria-hidden="true"
        />
        <div
          className="zpa-background-shape zpa-shape-two"
          aria-hidden="true"
        />

        <div className="zpa-container">
          <header className="zpa-heading">
            <div className="zpa-school-mark">
              <FaGraduationCap />
              <span>Zion Praise Academy Senior High School</span>
            </div>

            <div className="zpa-eyebrow">
              <span className="zpa-eyebrow-line" />
              Leadership &amp; Vision
              <span className="zpa-eyebrow-line" />
            </div>

            <h2>
              A Message From Our
              <span>School Proprietor</span>
            </h2>

            <p>
              At Zion Praise Academy, we believe education is more than
              academic achievement. It is the foundation for character,
              leadership, discipline, faith, and a meaningful future.
            </p>

            <div className="zpa-heading-rule" aria-hidden="true">
              <span />
              <span />
              <span />
            </div>
          </header>

          <div className="zpa-content">
            <aside className="zpa-image-column">
              <div className="zpa-image-wrapper">
                <div className="zpa-image-frame">
                  <img
                    src={proprietorImage}
                    alt="Mr. Sam A. Kargbo, Proprietor of Zion Praise Academy"
                    className="zpa-image"
                    loading="lazy"
                  />
                </div>

                <div
                  className="zpa-image-accent zpa-accent-one"
                  aria-hidden="true"
                />
                <div
                  className="zpa-image-accent zpa-accent-two"
                  aria-hidden="true"
                />

                <div className="zpa-role-card">
                  <div className="zpa-role-icon">
                    <FaGraduationCap />
                  </div>

                  <div>
                    <span>School Leadership</span>
                    <strong>Proprietor</strong>
                  </div>
                </div>
              </div>

              <div className="zpa-profile-caption">
                <FaCheckCircle />
                <span>
                  Committed to academic development, strong values, and a
                  learning environment where every student has the opportunity
                  to grow.
                </span>
              </div>
            </aside>

            <section className="zpa-message-column" aria-label="Message from the proprietor">
              <article className="zpa-message-card">
                <div className="zpa-quote-icon" aria-hidden="true">
                  <FaQuoteLeft />
                </div>

                <div className="zpa-message-top">
                  <span className="zpa-message-label">
                    From the Proprietor&apos;s Desk
                  </span>
                  <span className="zpa-message-line" />
                </div>

                <h3>
                  Building minds.
                  <span> Shaping character.</span>
                  <br />
                  Inspiring the future.
                </h3>

                <div className="zpa-message">
                  <p>
                    Welcome to Zion Praise Academy, where we are committed to
                    providing an environment in which every child can learn,
                    grow, discover their abilities, and develop the confidence
                    to become a responsible and productive member of society.
                  </p>

                  <p>
                    Our philosophy is built on the understanding that every
                    learner is uniquely gifted. Therefore, we strive to combine
                    strong academic instruction with character formation,
                    discipline, creativity, leadership development, and sound
                    moral values.
                  </p>

                  <p>
                    We are dedicated to working closely with our teachers,
                    parents, and the wider community to ensure that our students
                    receive the support and opportunities they need to succeed.
                    Our goal is not simply to prepare students for examinations,
                    but to prepare them for life.
                  </p>

                  <p>
                    As we continue to grow, we remain committed to excellence,
                    innovation, integrity, and the continuous improvement of our
                    educational standards. We believe that together, we can
                    nurture a generation capable of making a positive difference
                    in Liberia and beyond.
                  </p>
                </div>

                <div className="zpa-signature">
                  <div className="zpa-signature-mark">
                    <FaQuoteRight />
                  </div>

                  <div className="zpa-signature-text">
                    <strong>Mr. Sam A. Kargbo — Proprietor</strong>
                    <span>Zion Praise Academy</span>
                  </div>
                </div>
              </article>

              <div className="zpa-values">
                <div className="zpa-value">
                  <div className="zpa-value-icon">
                    <FaAward />
                  </div>

                  <div>
                    <strong>Academic Excellence</strong>
                    <span>
                      Developing capable, knowledgeable, and confident learners.
                    </span>
                  </div>
                </div>

                <div className="zpa-value">
                  <div className="zpa-value-icon">
                    <FaHeart />
                  </div>

                  <div>
                    <strong>Character &amp; Values</strong>
                    <span>
                      Building integrity, discipline, respect, and responsibility.
                    </span>
                  </div>
                </div>
              </div>

              <a href="#about" className="zpa-read-more">
                <span>Discover Our School</span>
                <FaArrowRight />
              </a>
            </section>
          </div>

          <section className="zpa-commitment" aria-label="Our school commitment">
            <div className="zpa-commitment-intro">
              <span>Our Commitment</span>
              <h4>Preparing students for success in school and in life.</h4>
            </div>

            <div className="zpa-commitment-item">
              <FaBookOpen />
              <span>Quality Education</span>
            </div>

            <div className="zpa-commitment-item">
              <FaShieldAlt />
              <span>Integrity &amp; Discipline</span>
            </div>

            <div className="zpa-commitment-item">
              <FaStar />
              <span>Excellence &amp; Leadership</span>
            </div>
          </section>

          <div className="zpa-bottom-note">
            <FaGraduationCap />
            <span>
              Zion Praise Academy Senior High School · Nurturing knowledge,
              character, and a brighter future.
            </span>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default PrincipalMessagePage;
